import { render, staticRenderFns } from "./questionType11.vue?vue&type=template&id=bab913ae"
import script from "./questionType11.vue?vue&type=script&lang=js"
export * from "./questionType11.vue?vue&type=script&lang=js"
import style0 from "./questionType11.vue?vue&type=style&index=0&id=bab913ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports